var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"cardapio-digital-cabecalho-header custom-header"},[_c('div',{staticClass:"cardapio-digital-cabecalho-container"},[_c('div',[_c('i',{staticClass:"cardapio-digital-cabecalho-btn-voltar is-clickable fas fa-arrow-left",on:{"click":function($event){return _vm.voltarListaGrupo()}}})]),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("Cardápio")])])
}]

export { render, staticRenderFns }